var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 11.8766V13.6183C10.3669 13.3517 9.60005 13.2699 8.84728 13.3798C8.0945 13.4897 7.37778 13.7882 6.7573 14.2502C6.13681 14.7121 5.63069 15.324 5.28142 16.0345C4.93215 16.745 4.74994 17.5333 4.75008 18.3333L3.16675 18.3325C3.1665 17.3149 3.38756 16.3107 3.81298 15.397C4.23841 14.4832 4.85691 13.6841 5.62109 13.0608C6.38527 12.4376 7.27485 12.0068 8.22166 11.8014C9.16848 11.5959 10.1474 11.6214 11.0834 11.8758V11.8766ZM9.50008 10.8333C6.87571 10.8333 4.75008 8.59581 4.75008 5.83331C4.75008 3.07081 6.87571 0.833313 9.50008 0.833313C12.1245 0.833313 14.2501 3.07081 14.2501 5.83331C14.2501 8.59581 12.1245 10.8333 9.50008 10.8333ZM9.50008 9.16665C11.2497 9.16665 12.6667 7.67498 12.6667 5.83331C12.6667 3.99165 11.2497 2.49998 9.50008 2.49998C7.7505 2.49998 6.33341 3.99165 6.33341 5.83331C6.33341 7.67498 7.7505 9.16665 9.50008 9.16665ZM15.8334 14.1666H18.2084V15.8333H15.8334V18.75L11.8751 15L15.8334 11.25V14.1666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon4);
export default __webpack_public_path__ + "static/media/dashboard-icon-4.86c7c7137468943007ff0d3db3502849.svg";
export { ForwardRef as ReactComponent };